import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ExpirySharedComponent } from './expiry.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';
import { InputAtomSharedModule } from '../../atoms/input/input.module';

@NgModule({
    declarations: [
        ExpirySharedComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        IconSharedModule,
        InputAtomSharedModule
    ],
    exports: [
        ExpirySharedComponent
    ]
})

export class ExpirySharedModule {}
